import React, { useContext, useEffect, useState } from "react";  

import {    

} from "./styled";
import ContainerAuthenticated from "containers/Authenticated";
import DashboardMenu from "components/Dashboard/Menu";
import { CoreContext } from "context/CoreContext";

export default function DashboardConversation() {

  const { currentCategory } = useContext(CoreContext);

  const [banners, setBanners] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [begining, setBegining] = useState(true);
  const [categoryCollections, setCategoryCollections] = useState([]);

  const init = async () => {
    // Definir tabs para conversa livre direcionando aos ChatBox05-08
    // Usando os mesmos personagens dos ChatBox originais com títulos correspondentes
    const conversationTabs = [
      {
        id: 105,
        attributes: {
          name: 'ChatBox05' // Baseado no ChatBox original (Salomão)
        },
        title: 'ChatBox05',
        image: '/images/card_nando_biblia.png'
      },
      {
        id: 107,
        attributes: {
          name: 'ChatBox07' // Lulu (Bíblico)
        },
        title: 'ChatBox07',
        image: '/images/card_lulu_biblia.png'
      }
    ];
    
    setTabs(conversationTabs);
    setBegining(false);
    setLoading(false);
  };

  useEffect(() => {
    init();
  }, []);

  // --- Para modo CONVERSA LIVRE - IDs dos novos ChatBox ---
  const idsFiltrados = [105, 106, 107, 108]; // IDs dos ChatBox para conversa livre
  const tabsFiltrados = tabs
    .filter(tab => idsFiltrados.includes(tab.id))
    .sort((a, b) => a.id - b.id); // Sort em ordem crescente por ID

  return (
    <>
      <ContainerAuthenticated primary page={'conversation'}>

        <div style={{ textAlign: 'center', margin: '20px 0' }}>
          <h1 style={{ color: 'var(--jk-text)', fontSize: '24px', marginBottom: '10px' }}>
            💬 Modo Chat Bíblico
          </h1>
          <p style={{ color: 'var(--jk-text)', fontSize: '16px' }}>
            Bate-papo Seguro e de Qualidade
          </p>
        </div>

        {
          begining ? null :
            <DashboardMenu tabs={tabsFiltrados} mode="conversation" />
        }

        {loading ?
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ color: 'var(--jk-text)' }}>Carregando...</div>
          </div>
          : null}

      </ContainerAuthenticated>
    </>
  );
} 